// tslint:disable: no-unused-expression
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'secondsToTime' })
export class SecondsToTimePipe implements PipeTransform {

  /* transform(): Pipe que Transforma una cantidad de segundos a horas:minutos:segundos
    value: Cantdad de tiempo en segundos
  */
  transform(value: number): string {
    // hours: Calcula las horas con base en los segundos
    let hours: any = Math.floor(value / 3600);
    // ↓ Reduce los segundos de acuerdo a las horas
    value = value % 3600;
    // mins: Calcula los minutos con base en los segundos
    const mins: any = Math.floor(value / 60);
    // ↓ Reduce los segundos de acuerdo a los minutos
    value = value % 60;
    // seconds: Segundos despúes de la reducción
    const seconds: any = value;
    // ↓ Modifica las horas en formato "00"
    hours < 10 ? hours = `0${hours}` : null;
    // ↓ Devuelve la composición hh:mm:ss del valor inicial
    return `${hours}:${('0' + mins).slice(-2)}:${('0' + seconds).slice(-2)}`;
  }

}
